import { useContext, useEffect, useState } from 'react';
import { GlobalContext } from 'Context/GlobalContext/AppContext';
import Pagination from '../Pagination';
import Table from 'components/organisms/Table';
import api from 'services/api';
import BaseModal from 'components/molecules/BaseModal';
import Footer from 'components/atoms/Footer';

const HistoryModal = () => {
    const { historyModal, setHistoryModal, setResponseMsg, setLoading, pagination, searchTerm } = useContext(GlobalContext);
    const [page, setPage] = useState(pagination.minPage);
    const [totalPages, setTotalPages] = useState(0);
    const [versoes, setVersoes] = useState([]);

    //Get history versions
    useEffect(() => {
        setLoading(true);
        api
            .getVersoes(historyModal.norma.TipoDoc, page, pagination.limit, historyModal.norma.NRDocumento)
            .then((response) => {
                const {
                    data: { Item, ID },
                } = response;
                setVersoes(Item);
                setTotalPages(Math.ceil(ID / pagination.limit));
            })
            .catch((error) => {
                console.error(error);
                setResponseMsg({ isVisible: true, error: true, msg: error.message });
            })
            .finally(() => setLoading(false));
    }, [page, pagination.limit, searchTerm, setVersoes, historyModal.norma.NRDocumento, setLoading, setResponseMsg]);

    return (
        <BaseModal
            isVisible={historyModal.isVisible}
            handleClose={() =>
                setHistoryModal((prevState) => ({
                    ...prevState,
                    isVisible: false,
                }))
            }
        >
            <h3>Histórico de Versões</h3>
            {versoes.length > 0 && <Table rows={versoes} tipoDoc={historyModal.norma.TipoDoc} />}
            {versoes.length > 0 ? (
                <Pagination totalPages={totalPages} page={page} setPage={setPage} />
            ) : (
                <Footer>Não existem versões anteriores para o documento presente.</Footer>
            )}
        </BaseModal>
    );
};

export default HistoryModal;
